var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNonDrinkingSource(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 53,
    viewBox: "0 0 47 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2676_627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.145 28.6649C45.239 32.8306 42.965 36.4129 38.113 40.7784C37.9947 40.8866 25.6147 51.2057 23.8633 52.6655C23.7434 52.7655 23.5738 52.7652 23.4545 52.6645C21.7041 51.1869 9.2618 40.6842 9.14332 40.5759C3.93814 36.0924 0.671875 30.0708 0.671875 23.2562C0.671875 10.3221 11.8023 -0.0573493 25.1829 0.788512C39.316 1.68195 49.096 15.0967 46.145 28.6649Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7467 41.738C34.262 41.738 42.7863 33.3881 42.7863 23.088C42.7863 12.7879 34.262 4.43799 23.7467 4.43799C13.2314 4.43799 4.70703 12.7879 4.70703 23.088C4.70703 33.3881 13.2314 41.738 23.7467 41.738Z",
    fill: "#FF6A4D",
    stroke: "#F94848",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9232 14.3184L27.8445 33.198H19.4107L16.3359 14.3184H30.9232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2182 28.2561L15.6328 27.7014L30.3023 12.8179L30.8877 13.3726L16.2182 28.2561Z",
    fill: "#FF6A4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7221 31.4779L18.1367 30.9231L32.8051 16.0386L33.3906 16.5933L18.7221 31.4779Z",
    fill: "#FF6A4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7415 6.49268C14.4888 6.49268 6.96289 13.8753 6.96289 22.9386C6.96289 32.0019 14.4888 39.374 23.7415 39.374C32.9943 39.374 40.531 32.002 40.531 22.9386C40.531 13.8752 32.9943 6.49268 23.7415 6.49268ZM9.13489 22.9386C9.13489 15.0454 15.6944 8.62023 23.7415 8.62023C27.0865 8.62023 30.1814 9.72653 32.6467 11.5988L12.5015 32.0552C10.3946 29.5766 9.13489 26.4065 9.13489 22.9386ZM23.7415 37.2464C20.4074 37.2464 17.3125 36.1401 14.8473 34.2785L34.9926 13.8115C37.0885 16.29 38.359 19.4707 38.359 22.9386C38.359 30.8212 31.7997 37.2464 23.7415 37.2464Z",
    fill: "#3D3D3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2676_627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 52,
    fill: "white",
    transform: "translate(0.671875 0.740234)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonDrinkingSource);
export default __webpack_public_path__ + "static/media/non-drinking-source.ad311fbbe021a31aa95ae924f6fe7e89.svg";
export { ForwardRef as ReactComponent };